import { Link } from 'react-router-dom';
import { NAV_LINKS } from '../../data/navigation';
import { assetUrl } from '../../lib/assetUrl';
import ContactDetails from './ContactDetails';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer id="contact" className="site-footer">
      <div className="container">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <img
              src={assetUrl('images/logo-nobg.png')}
              alt="Paw Global Veterinary"
              width="1728"
              height="910"
              loading="lazy"
            />
            <p className="muted">Advancing pet care across Asia from our clinic in Phnom Penh.</p>
          </div>

          <nav className="site-footer__nav" aria-label="Footer">
            <h2 className="site-footer__heading">Explore</h2>
            <ul>
              {NAV_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="site-footer__contact">
            <h2 className="site-footer__heading">Contact PAW Global Veterinary</h2>
            <ContactDetails />
          </div>
        </div>

        <div className="site-footer__bottom">
          <p>&copy; {year} PAW Global Veterinary. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
